module.exports = __webpack_public_path__ + "img/left-arrow.c72c15e7.png";